import { REMOVE_POPUP_TYPES } from '@/constants/itinerary/userDialogue'
import { replacePlaceholders } from '@/utils'

export const isRemovePopup = (dialogueType?: string) =>
    REMOVE_POPUP_TYPES.includes(dialogueType as (typeof REMOVE_POPUP_TYPES)[number])

const getDialogues = (response: any) => {
    const components = response?.data?.components || []
    return (
        components.find((component: { type?: string }) => component?.type === 'USER_DIALOGUE')?.data
            ?.dialogues || []
    )
}

export const hasRemovePopup = (response: any) =>
    getDialogues(response).some((dialogue: { dialogueType?: string }) =>
        isRemovePopup(dialogue?.dialogueType)
    )

let pendingRemoveRequest: { updateRequestList: any[] } | null = null

export const savePendingRemove = (response: any, payload?: { updateRequestList?: any[] } | null) => {
    if (hasRemovePopup(response) && payload?.updateRequestList?.[0]) {
        pendingRemoveRequest = payload as { updateRequestList: any[] }
        return
    }
    pendingRemoveRequest = null
}

export const buildConfirmedRemove = (linkedActions?: string[]) => {
    const request = pendingRemoveRequest?.updateRequestList?.[0]
    if (!request) return null
    return {
        updateRequestList: [
            {
                ...request,
                timestamp: Date.now(),
                ...(linkedActions?.length ? { linkedActions } : {})
            }
        ]
    }
}

export const clearPendingRemove = () => {
    pendingRemoveRequest = null
}

export const getDialogueDisplayMessage = (message: any = {}) => {
    const raw = message?.placeholders
    const placeholderMap: Record<string, string> = Array.isArray(raw)
        ? raw.reduce((acc: Record<string, string>, placeholder: { title?: string; value?: string }) => {
            if (placeholder?.title) acc[placeholder.title] = placeholder.value ?? ''
            return acc
        }, {})
        : (raw && typeof raw === 'object' ? raw : {})
    return {
        title: replacePlaceholders(message?.title || '', placeholderMap),
        subTitle: replacePlaceholders(message?.subTitle || '', placeholderMap),
        placeholderMap,
    }
}
